import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import Parser from './Parser.js';
import Rule from './Rule.js';
import PostRule from './PostRule.js';
import CalEventFactory from './CalEventFactory.js';

/**
 * handles one rule
 */
var DateFn = /*#__PURE__*/function () {
  /**
   * @param {string} rule - unparsed rule
   * @param {array} holidays - all holidays rules (required for bridge day calculations)
   */
  function DateFn(ruleStr, holidays) {
    _classCallCheck(this, DateFn);
    var parser = new Parser();
    this.ruleStr = ruleStr;
    this.rules = parser.parse(ruleStr);
    this.ok = !parser.error;
    this.holidays = holidays;
    this.opts = holidays ? holidays[ruleStr] : {};
    this.event = undefined;
    this.cache = new Map();
  }

  /**
   * @param {number} year
   * @returns {this}
   */
  _createClass(DateFn, [{
    key: "inYear",
    value: function inYear(year) {
      if (this.cache.has(year)) {
        this.event = this.cache.get(year);
        return this;
      }
      var ruleFn; // current rule
      var postProc = new PostRule(this.ruleStr, this.opts, this.holidays);
      this.rules.forEach(function (rule) {
        if (rule.fn) {
          var calEvent = new CalEventFactory(rule).inYear(year - 1) // run over neighboring dates to catch overlaps
          .inYear(year).inYear(year + 1);
          postProc.push(calEvent);
          ruleFn = new Rule(calEvent);
        } else {
          if (ruleFn.resolve(rule)) {
            postProc.resolve(rule, year);
          }
        }
      });
      var event = postProc.getEvent(year);
      this.cache.set(year, event);
      this.event = event;
      return this;
    }
  }, {
    key: "get",
    value: function get(timezone) {
      return this.event.get(timezone);
    }
  }]);
  return DateFn;
}();
export { DateFn as default };